module.exports = __webpack_public_path__ + "static/media/user-placeholder-female.7e0a0aa3.jpg";